import { DomainHealthRecord } from "../../../../domain/healthRecord";
import { dayjs, localizedDate } from "../../../../utils/dayjs";

export function buildHealthRecordOptionLabel(
  healthRecord: DomainHealthRecord,
  locale: Parameters<typeof localizedDate>[1],
): string {
  return `${healthRecord.lastName.toUpperCase()} ${healthRecord.firstNames} - ${localizedDate(
    healthRecord.birthDate,
    locale,
  )}`;
}

export function hasEvcIdentityMismatch(
  evcFullName: string | null,
  evcDateOfBirth: string | null,
  selectedHealthRecord?: DomainHealthRecord,
): boolean {
  if (!selectedHealthRecord) {
    return false;
  }

  const healthRecordName = `${selectedHealthRecord.firstNames} ${selectedHealthRecord.lastName}`;
  const healthRecordDateOfBirth = dayjs.utc(selectedHealthRecord.birthDate).format("YYYY-MM-DD");

  return (
    (!!evcFullName && normalizeIdentityValue(evcFullName) !== normalizeIdentityValue(healthRecordName)) ||
    (!!evcDateOfBirth && evcDateOfBirth !== healthRecordDateOfBirth)
  );
}

function normalizeIdentityValue(value: string): string {
  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim()
    .replace(/\s+/g, " ");
}
